module.exports = __webpack_public_path__ + "img/chevron-left.3e558875.svg";